export default __webpack_public_path__ + "static/media/bkg--location-aerial.2ee214b1.jpg";